import { render, staticRenderFns } from "./HeaderButton.vue?vue&type=template&id=1f0694e3&scoped=true&"
import script from "./HeaderButton.vue?vue&type=script&lang=js&"
export * from "./HeaderButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0694e3",
  null
  
)

export default component.exports